import $ from "jquery";

const openCloseFilter = () => {
  const init = () => {
    execute();
    applyButton();
  };

  const execute = () => {
    const el = {
      filter: ".js-box-filter",
      filterTags: ".js-box-filter-tags",
      buttonOpen: ".js-toggle-filter__open",
      buttonClose: ".js-toggle-filter__close",
      filterText: ".js-toggle-filter__open span",
      buttonSubmit: "#applyFilter",
    };

    if ($(el.buttonOpen).length === 0) return;

    if (window.screen.width < 600) {
      $(el.filter).hide();
      $(el.filterTags).hide();

      // set text button from php string in data-text prop
      const text = $(el.filterText).data("text");
      $(el.filterText).text(text[0]);

      if ($(el.buttonOpen).length !== 0) {
        $(el.filterTags).hide();
      }

      $(document).on("click", el.buttonOpen, function () {
        $(el.filter).slideDown("slow");
        if ($(el.buttonOpen).length !== 0 || window.screen.width > 600) {
          $(el.filterTags).slideToggle("slow");
        }

        $(el.filterText).text(text[1]);
      });

      $(document).on(
        "click",
        el.buttonClose + "," + el.buttonSubmit,
        function () {
          $(el.filter).slideUp("slow");
          $(el.filterText).text(text[0]);
        }
      );
    } else {
      $(el.filter).show();
      if ($(el.button).length !== 0) {
        // $(el.filterTags).hide();
      }
    }
  };

  const applyButton = () => {
    const el = {
      button: ".js-toggle-filter__open",
      buttonClose: ".js-toggle-filter__close",
      buttonItem: ".js-filter-checkbox",
      countItem: ".js-box-filter .js-filter-count",
      tag: ".box-filter-tags",
      boxFilter: ".js-box-filter",
      clearButton: ".js-button-filter-clear",
      buttonSubmit: "#applyFilter",
    };

    $(document).on("click", el.button, function () {
      $(el.button).parent().toggleClass("opened");

      if ($(this).parent().hasClass("opened")) {
        $("body").css("overflow-y", "hidden");
      } else {
        $("body").css("overflow-y", "auto");
      }
    });

    $(document).on(
      "click",
      el.buttonClose + "," + el.buttonSubmit,
      function () {
        $(el.button).parent().toggleClass("opened");

        if ($(this).parent().hasClass("opened")) {
          $("body").css("overflow-y", "hidden");
        } else {
          $("body").css("overflow-y", "auto");
        }
      }
    );
  };

  init();
};
try {
  openCloseFilter();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
